import { useMemo } from "react";
import PackRequestTypes from "enums/packRequestTypes";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";

export interface RequestData {
  type: PackRequestTypes;
  title: string;
}

export const useRequestData = (isTrial: boolean, isExpired: boolean, isPurchased: boolean): RequestData => {
  const additionalPurchaseEnabled = useFeatureFlag(FeatureFlags.AdditionalPurchase);

  return useMemo(() => {
    if (!isPurchased || !additionalPurchaseEnabled) {
      return { type: PackRequestTypes.RequestPack, title: "Request Pack" };
    }
    if (isExpired) {
      return { type: PackRequestTypes.RequestPackRenewal, title: "Request Renewal" };
    }
    if (isTrial) {
      return { type: PackRequestTypes.RequestTrialConvert, title: "Request Pack" };
    }
    return { type: PackRequestTypes.RequestExtraLicenses, title: "Request More Licenses" };
  }, [isExpired, isTrial, isPurchased, additionalPurchaseEnabled]);
};
